import React from "react";
import { makeStyles } from "@material-ui/core";
import { Container, Link } from "@material-ui/core";
import logo from "bb-logo.png";

const useStyles = makeStyles((theme) => ({
  sideBar: {
    width: 100,
    height: "100%",
    top: 0,
    bottom: 0,
    background: "#0D5876 0% 0% no-repeat padding-box",
  },
  logo: {
    position: "relative",
    width: 50,
    top: 30,
  },
}));

const ReportsSideBar = () => {
  const classes = useStyles();

  return (
    <Container className={classes.sideBar} role="complementary">
      <Link href="https://library.biblioboard.com" target="_blank">
        <img className={classes.logo} src={logo} alt="BiblioBoard Logo" />
      </Link>
    </Container>
  );
};

export default ReportsSideBar;
